// NotFound.jsx
import './assets/styles/web.css';
import notFoundImge from './404.svg';

import Footer from "./components/common/Footer";
import TopMenu from "./components/common/TopMenu";
import LandingPageData from "./static/landingPage";

//import { Image } from "react-bootstrap";
const NotFound = ({
    menuData,
    activePage,
    handlePageChange,
    activePageLayoutType,
}) => {
    return (
        <>
            <TopMenu
                menuData={menuData}
                activePage={activePage}
                handlePageChange={handlePageChange}
                activePageLayoutType={activePageLayoutType}
              />
            <div className="not-found">
                <div className="not-found__container">
                    <div className="not-found__text">
                    {/* <Image
                        alt="error-404-illustration"
                        src={notFoundImge}
                        className="not-found__image"
                    /> */}
                    <img height={100}
                        src={notFoundImge}
                        alt="error-404-illustration"
                        className="not-found__image"
                    />
                    <h4 className="not-found__title">Page Not Found </h4>
                    <p className="not-found__message">We couldn't find the page you are looking for.</p>
                    </div>
                    <a className="not-found__button" href="/">Back To Home</a>
                    
                </div>
            </div>
            <Footer
                menuData={menuData}
                activePage={activePage}
                handlePageChange={handlePageChange}
                activePageLayoutType={activePageLayoutType}
                copyRightText={LandingPageData.copyRight}
            />
        </>
    );
  }

export default NotFound;